"use client";

import { Calendar, Euro, MapPin, Plane } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  label: "Cena",
  value: "€1300",
  icon: Euro
}, {
  label: "Termin",
  value: "17-28 Sierpnia",
  icon: Calendar
}, {
  label: "Lokalizacja",
  value: "Lamai, Koh Samui",
  icon: MapPin
}, {
  label: "Loty",
  value: "Zakup własny",
  icon: Plane
}];
export default function KluczoweInformacje() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="kluczowe-informacje" className="dark bg-background text-foreground relative border-y border-border/50 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-primary/10 pointer-events-none"></div>

      {}
      <div className="absolute inset-0 opacity-[0.04] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583198/img/generic_noise_texture.png)] bg-repeat pointer-events-none mix-blend-overlay"></div>

      <div ref={ref} className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 divide-y sm:divide-y-0 sm:divide-x divide-border/30">
          {stats.map((stat, i) => {
          const Icon = stat.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center justify-center text-center pt-8 sm:pt-0 first:pt-0 px-4">
                <Icon className="w-6 h-6 text-primary mb-4 opacity-80" strokeWidth={1.5} />
                <span className="text-4xl lg:text-5xl font-bold font-serif tracking-tight text-foreground mb-2">
                  {stat.value}
                </span>
                <span className="text-sm font-medium text-muted-foreground uppercase tracking-widest">
                  {stat.label}
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}